import moment from 'moment';

function formatPhoneNumber(phoneNumber) {
  return phoneNumber.match(/.{1,2}/g)?.join(' ');
}

function getHeader(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function getTimesOutsideRange(startTime, endTime) {
  const start = new Date();
  const end = new Date();
  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);

  start.setHours(startHour, startMinute, 0, 0);
  end.setHours(endHour, endMinute, 0, 0);

  const timesOutsideRange = [];

  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const currentTime = new Date();
      currentTime.setHours(hour, minute, 0, 0);

      if (currentTime < start || currentTime > end) {
        timesOutsideRange.push(currentTime);
      }
    }
  }

  return timesOutsideRange;
}

function getDatesWithinRange(bookingStart, bookingEnd, daysOfWeek) {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Réinitialise l'heure pour comparer uniquement les dates
  const start = new Date(bookingStart) < today ? today : new Date(bookingStart);
  const end = new Date(bookingEnd);
  const dates = [];

  for (let date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
    if (daysOfWeek.includes(String(date.getDay()))) {
      dates.push(new Date(date));
    }
  }

  return dates;
}


// Example usage:
const startTime = '08:00';
const endTime = '16:00';
const timesOutsideRange = getTimesOutsideRange(startTime, endTime);
console.log(timesOutsideRange);

function formatDate(value) {
  let date = new Date(value);
  const day = date.toLocaleString('default', {day: '2-digit'});
  const month = date.toLocaleString('default', {month: 'short'});
  const year = date.toLocaleString('default', {year: 'numeric'});
  return (
    day + ' ' + month.charAt(0).toUpperCase() + month.slice(1) + ' ' + year
  );
}

function formatHourDatePicker(value) {
  return moment(value).format('HH:mm');
}

function formatLongDatePicker(date) {
  return moment(date).format('D MMMM YYYY');
}

function formatHour(value) {
  return moment.unix(new Date(value)).format('HH:mm');
}

function formatLongDate(date) {
  return moment.unix(new Date(date * 1000)).format('D MMMM YYYY');
}

function formatMaterialDate(date) {
  return date ? moment.unix(new Date(date)).format('YYYY-MM-DD') : '';
}

function shortDateFormat(date) {
  return moment(new Date(date * 1000)).format('D MMM YYYY');
}

function truncateStr(str, n) {
  return str.length > n ? str.slice(0, n - 1) + ' ...' : str;
}

function removeHtml(html) {
  const div = document.createElement('div');
  div.innerHTML = html;

  return div.textContent || div.innerText || '';
}

function isMailValid(mail) {
  const regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
  return regex.test(mail);
}

function formatToVcalendarDate(value) {
  return moment.utc(value * 1000).format('YYYYMMDDTHHmmss[Z]');
}

function concatStrings(arr, len) {
  const str = arr.join(', ');
  return str.length > len ? str.slice(0, len) + '...' : str;
}

export {
  formatPhoneNumber,
  getHeader,
  formatDate,
  formatHour,
  shortDateFormat,
  truncateStr,
  removeHtml,
  formatLongDate,
  formatHourDatePicker,
  formatLongDatePicker,
  formatMaterialDate,
  isMailValid,
  formatToVcalendarDate,
  concatStrings,
  getTimesOutsideRange,
  getDatesWithinRange
};
